import { render, staticRenderFns } from "./header-primary.vue?vue&type=template&id=87e44214&scoped=true"
import script from "./header-primary.vue?vue&type=script&lang=js"
export * from "./header-primary.vue?vue&type=script&lang=js"
import style0 from "./header-primary.vue?vue&type=style&index=0&id=87e44214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e44214",
  null
  
)

export default component.exports